import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_SHIPPING_COST_TABLE,
    REQUEST_SHIPPING_COST_TABLE,
    SUCCESS_SHIPPING_COST_TABLE,
} from 'src/store/shipping-cost-table/actions';

function shippingCostTableReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_SHIPPING_COST_TABLE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SHIPPING_COST_TABLE: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_SHIPPING_COST_TABLE:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export default shippingCostTableReducer;
